import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PrimaryBtnSkeleton: React.FC = () => {
  return (
    <Skeleton 
      width="100%" 
      height={55} 
      borderRadius={8}
    />
  );
};

export default PrimaryBtnSkeleton;
